import { FragmentOf, readFragment } from 'gql.tada'

import AttentionIcon from '@/assets/icons/ic_logic-g-app_attention.svg'
import { Modal, ModalProps } from '@/components/modal'
import { Button } from '@/components/ui/button'
import Link from '@/update-monitor/Link'

import { PlayerSubscriptionInfo_player } from '../PlanSettings'

interface Props extends ModalProps {
  player: FragmentOf<typeof PlayerSubscriptionInfo_player>
  index: number
}

export const CancelMainPlanModal = (props: Props): JSX.Element => {
  const player = readFragment(PlayerSubscriptionInfo_player, props.player)
  return (
    <Modal
      customStyles={{
        content: {
          padding: '48px 35px',
          width: '600px',
        },
      }}
      {...props}
    >
      <h3 className="mb-[15px] mt-[10px] text-center text-2xl font-bold tracking-widest text-primary-text">
        利用プランの解約
      </h3>
      <div>
        <p>
          現在、{player.name || `プレイヤー${props.index + 1}`}
          さんの主契約に基づく「きょうだい割引」をその他のプレイヤーに適用しているため、
          {player.name || `プレイヤー${props.index + 1}`}
          さんの自動更新を停止することはできません。
          {player.name || `プレイヤー${props.index + 1}`}
          さんのプランの自動更新を停止するには、主契約者をその他のプレイヤーに変更してください。
          その場合、変更されたプレイヤーは通常料金に、
          {player.name || `プレイヤー${props.index + 1}`}
          さんは、「きょうだい割引」が適用されます。
        </p>

        <div className="mb-6 mt-4 flex justify-center">
          <AttentionIcon width={104} aria-hidden={true} />
        </div>

        <Button variant="secondary" className="mx-auto flex w-[270px]" asChild={true}>
          <Link
            href={{
              pathname: '/web/switch-subscription',
              query: { playerId: player.id, index: props.index },
            }}
          >
            切り替える
          </Link>
        </Button>
      </div>
    </Modal>
  )
}
